/**
 * Converting empty HTML tags to empty strings.
 * This is useful for rich text editors that may return empty tags like <p></p>
 * when the content is actually empty.
 */
export const normalizeHtmlValue = (value: string): string => {
    return value.replace(/<\/?[^>]+(>|$)/g, '').trim() === '' ? '' : value
}
